import { Icon, IconProps } from "@chakra-ui/react";
import type { ElementType } from "react";
import type { IconType } from "react-icons";

export function Mark(props: IconProps & { as: ElementType | IconType }) {
  const { as: Comp, ...rest } = props;
  return <Icon {...rest} as={Comp as any} />;
}
